module.exports = __webpack_public_path__ + "static/media/c.21fa12f7.svg";